export default __webpack_public_path__ + "images/0x7a08bf5304094ca4c7b4132ef62b5edc4a3478b7.png";